module.exports = __webpack_public_path__ + "img/no-properties.c9dd8f60.svg";